import p1_img from "./product_12.png";
import p2_img from "./product_35.png";
import p3_img from "./product_14.png";
import p4_img from "./product_8.png";
import p5_img from "./product_15.png";
import p6_img from "./product_2.png";
import p7_img from "./product_17.png";
import p8_img from "./product_28.png";

let new_collections = [
  {
    id: 12,
    name: "Sound Of Metal",
    year: "2020",
    genre: "Drama, Music",
    image: p1_img,
    streaming_price: 2.99,
    streaming_old_price: 7.99,
  },
  {
    id: 35,
    name: "Morbius",
    year: "2022",
    genre: "Action, Adventure, Drama",
    image: p2_img,
    streaming_price: 1.99,
    streaming_old_price: 6.99,
  },
  {
    id: 14,
    name: "Godzilla vs. Kong",
    year: "2021",
    genre: "Action, Sci-Fi, Thriller",
    image: p3_img,
    streaming_price: 5.49,
    streaming_old_price: 10.49,
  },
  {
    id: 8,
    name: "The Trial Of The Chicago 7",
    year: "2020",
    genre: "Drama, History, Thriller",
    image: p4_img,
    streaming_price: 4.49,
    streaming_old_price: 9.49,
  },
  {
    id: 15,
    name: "Dune",
    year: "2021",
    genre: "Adventure, Drama, Sci-Fi",
    image: p5_img,
    streaming_price: 6.99,
    streaming_old_price: 11.99,
  },
  {
    id: 2,
    name: "Wonder Woman 1984",
    year: "2020",
    genre: "Action, Adventure, Fantasy",
    image: p6_img,
    streaming_price: 3.99,
    streaming_old_price: 8.99,
  },
  {
    id: 17,
    name: "A Quiet Place - Part II",
    year: "2020",
    genre: "Drama, Horror, Sci-Fi",
    image: p7_img,
    streaming_price: 3.99,
    streaming_old_price: 8.99,
  },
  {
    id: 28,
    name: "Space Jam: A New Legacy",
    year: "2021",
    genre: "Animation, Adventure, Comedy",
    image: p8_img,
    streaming_price: 2.99,
    streaming_old_price: 7.99,
  },
];

export default new_collections;
